"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.VISIT_DURATION = exports.KameleoonStorageKey = exports.DEFAULT_CLIENT_CONFIGURATION = void 0;
var _clientConfiguration = require("../clientConfiguration"),
  _types = require("../types");
var KameleoonStorageKey = exports.KameleoonStorageKey = function (a) {
  return a.ClientData = "kameleoonClientData", a.TargetingData = "kameleoonTargetingData", a.TrackingData = "kameleoonTrackingData", a.VariationData = "kameleoonVariationData", a.VisitorCode = "kameleoonVisitorCode", a.ConsentData = "kameleoonConsentData", a.DataInfo = "kameleoonDataInfo", a.KameleoonSimulationFFData = "kameleoonSimulationFFData", a.ForcedFeatureVariation = "kameleoonForcedFeatureVariation", a.ForcedExperimentVariation = "kameleoonForcedExperimentVariation", a;
}({});
var DEFAULT_CLIENT_CONFIGURATION = exports.DEFAULT_CLIENT_CONFIGURATION = {
    data: {
      customData: [],
      featureFlags: [],
      configuration: {
        realTimeUpdate: !1,
        consentType: _clientConfiguration.ConsentType.NotRequired,
        dataApiDomain: "data.kameleoon.io"
      }
    },
    lastUpdate: ""
  },
  VISIT_DURATION = exports.VISIT_DURATION = 29 * _types.Milliseconds.Minute;